import type { ParamMatcher } from '@sveltejs/kit';

export const match: ParamMatcher = (param): param is number & 'private' => {
  // Test if is number or the word "private"
  return /^(private|\d+)$/.test(param);
};
